/** Stable React Query keys for calendar-domain resources. */

const calendars = () => ['calendars'] as const;

const events = (params: { from: string; to: string; calendarId?: string }) =>
  ['events', params.from, params.to, params.calendarId ?? 'all'] as const;

const tasks = (params?: { calendarId?: string; status?: string; dueAfter?: string; dueBefore?: string }) =>
  ['tasks', params?.calendarId ?? 'all', params?.status ?? 'all', params?.dueAfter ?? '', params?.dueBefore ?? ''] as const;

const notes = (params?: { calendarId?: string; from?: string; to?: string }) =>
  ['notes', params?.calendarId ?? 'all', params?.from ?? '', params?.to ?? ''] as const;

const orgHolidays = () => ['org', 'holidays'] as const;

const orgWideEvents = (params?: { from?: string; to?: string }) =>
  ['org', 'wide-events', params?.from ?? '', params?.to ?? ''] as const;

const orgSchedule = () => ['org', 'schedule'] as const;

const meetings = (params?: { from?: string; to?: string }) =>
  ['meetings', params?.from ?? '', params?.to ?? ''] as const;

const calendarVisibility = () => ['me', 'calendar-visibility'] as const;

const hrmsHolidays = () => ['hrms', 'holidays'] as const;

const hrmsAttendanceCurrentStatus = () => ['hrms', 'attendance', 'current-status'] as const;

const hrmsAttendanceDailyReport = (date: string) => ['hrms', 'attendance', 'admin', 'report', 'daily', date] as const;

const hrmsAttendanceMonthlyReport = (year: string, month: string) =>
  ['hrms', 'attendance', 'report', 'monthly', year, month] as const;

export const queryKeys = {
  calendars,
  events,
  tasks,
  notes,
  orgHolidays,
  orgWideEvents,
  orgSchedule,
  meetings,
  calendarVisibility,
  hrmsHolidays,
  hrmsAttendanceCurrentStatus,
  hrmsAttendanceDailyReport,
  hrmsAttendanceMonthlyReport,
};
